const LEGAL_ENTITY_DOCUMENT_CODE: Record<string, true> = {
  '31-NIT': true,
  '50-FOREIGN_NIT': true,
  FOREIGNNIT: true
}

const COLOMBIAN_NIT_WEIGHTS = [71, 67, 59, 53, 47, 43, 41, 37, 29, 23, 19, 17, 13, 7, 3]

const POS_CUSTOMER_DOCUMENT_CODES = new Set([
  '13-CC',
  '22-CE',
  '31-NIT',
  '41-PA'
])

export function isThirdPartyLegalEntityDocumentCode(code: unknown) {
  return typeof code === 'string' && LEGAL_ENTITY_DOCUMENT_CODE[code.trim().toUpperCase()] === true
}

export function isPosCustomerDocumentTypeCode(code: unknown) {
  return typeof code === 'string' && POS_CUSTOMER_DOCUMENT_CODES.has(code.trim().toUpperCase())
}

function calculateColombianNitDigit(digits: string) {
  const offset = COLOMBIAN_NIT_WEIGHTS.length - digits.length
  let sum = 0
  for (let index = 0; index < digits.length; index += 1) {
    sum += Number(digits[index]) * COLOMBIAN_NIT_WEIGHTS[offset + index]!
  }
  const remainder = sum % 11
  return String(remainder < 2 ? remainder : 11 - remainder)
}

export function calculateColombianNitVerificationDigit(value: unknown) {
  if (typeof value !== 'string' && typeof value !== 'number') return ''
  const input = String(value).trim()
  const separator = input.indexOf('-')
  const digits = (separator < 0 ? input : input.slice(0, separator)).replace(/[.\s]/g, '')
  if (!/^\d{1,15}$/.test(digits)) return ''
  return calculateColombianNitDigit(digits)
}

export function displayColombianNitVerificationDigit(value: unknown) {
  if (typeof value !== 'string' && typeof value !== 'number') return ''
  const digits = String(value).trim().replace(/[.\s_-]/g, '')
  const body = digits.slice(0, -1)
  if (body && calculateColombianNitDigit(body) === digits.at(-1)) return digits.at(-1)!
  return calculateColombianNitVerificationDigit(value)
}

export function colombianNitBodyFromStoredDocument(value: unknown) {
  if (typeof value !== 'string' && typeof value !== 'number') return ''
  return String(value).trim().replace(/[.\s_-]/g, '').slice(0, -1)
}

export function appendColombianNitVerificationDigit(value: unknown) {
  if (typeof value !== 'string' && typeof value !== 'number') return ''
  const input = String(value).trim()
  if (input.includes('-')) return input.replace(/[.\s_-]/g, '')
  const digits = input.replace(/[.\s]/g, '')
  const digit = calculateColombianNitVerificationDigit(digits)
  return digit ? `${digits}${digit}` : input
}
